import { RoleData } from "../../components/Administration/RolesPermissions/PermissionsRoleModal"
import { ObservableFromFetch } from "../ObservableFromFetch"
import Role from "../Roles/Model/Role"

export interface Permission {
  PermissionID: number
  Title: string
  Description?: string
  RecordStatusType?: string
  ActiveDate?: string
  InActiveDate?: string
  ModifiedBy?: string
  UpdateDate?: string
  ApprovedBy?: string
  ApprovedOn?: string
  Role?: string
  Permission?: string
  SubscriptionPlan?: string
  SubscriptionPlanID?: number
}

// Subscription
export default function PermissionsGet() {
  return ObservableFromFetch<Permission[]>("FFOrderPermissionSubscription/GetPermission")
}

export function UnassignedSubscriptionPermissionsGet() {
  return ObservableFromFetch<Permission[]>("FFOrderSubscriptionPermission/GetNotAssignedPermission")
}

export function PermissionsOfSubscriptionPlanGet(id: number, title: string) {
  const requestBody: string = new URLSearchParams({
    subscriptionPlanID: id.toString(),
    subscriptionPlanTitle: title
  }).toString()

  return ObservableFromFetch<Permission[]>("FFOrderSubscriptionPermission/GetAssignedPermissionOfSubscriptionPlan?" + requestBody)
}

export function NotAssignedPermissionsOfSubscriptionPlanGet(id: number, title: string) {
  const requestBody: string = new URLSearchParams({
    subscriptionPlanID: id.toString(),
    subscriptionPlanTitle: title
  }).toString()

  return ObservableFromFetch<Permission[]>("FFOrderSubscriptionPermission/GetNotAssignedPermissionOfSubscriptionPlan?" + requestBody)
}

export function SubscriptionPlanPermissionSave(subscriptionPlanID: number, description: string, modifiedBy: string, permissions: Permission[]) {
  const requestBody: string = JSON.stringify({
    SubscriptionPlanID: subscriptionPlanID,
    Description: description,
    ModifiedBy: modifiedBy,
    AssignedPermission: permissions
  })

  return ObservableFromFetch<string>("FFOrderSubscriptionPermission/SaveSubscriptionPlanPermission", requestBody)
}

// Permissions Approval
export function PendingPermissionsGet() {
  return ObservableFromFetch<Permission[]>("FFOrderPermissionApproval/GetPendingPermission")
}

export function InactivePermissionsGet() {
  return ObservableFromFetch<Permission[]>("FFOrderPermissionApproval/GetInActivePermission")
}

export function PermissionsApprove(permissions: Permission[], approvedBy: string) {
  const requestBody = JSON.stringify({
    ApprovePermission: permissions,
    ApprovedBy: approvedBy
  })
  return ObservableFromFetch<string>("FFOrderPermissionApproval/ApprovedPermission", requestBody)
}

// Role
export function RolesGet() {
  return ObservableFromFetch<Role[]>("FFOrderRolePermission/GetRole")
}

export function PermissionsOfRoleGet(id: number, title: string) {
  const requestBody: string = new URLSearchParams({
    roleID: id.toString(),
    roleTitle: title
  }).toString()

  return ObservableFromFetch<Permission[]>("FFOrderRolePermission/GetAssignedPermissionOfRole?" + requestBody)
}

export function NotAssignedPermissionsOfRoleGet(id: number, title: string) {
  const requestBody: string = new URLSearchParams({
    roleID: id.toString(),
    roleTitle: title
  }).toString()

  return ObservableFromFetch<Permission[]>("FFOrderRolePermission/GetNotAssignedPermissionOfRole?" + requestBody)
}

export function RoleCreate(data: RoleData) {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderRolePermission/CreateRole", requestBody)
}

export function PermissionInRoleSave(data: RoleData | undefined, permissions: Permission[]) {
  const requestBody: string = JSON.stringify({
    RoleID: data?.RoleID,
    ModifiedBy: data?.ModifiedBy,
    Level: data?.Level,
    Description: data?.Description,
    ActiveDate: data?.ActiveDate,
    InActiveDate: data?.InActiveDate,
    AssignedPermission: permissions,
  })

  return ObservableFromFetch<string>("FFOrderRolePermission/SavePermissionInRole", requestBody)
}

// Subscriptions/Permissions Relationship
export function PendingSubscriptionsPermissionsMappingGet() {
  return ObservableFromFetch<Permission[]>("FFOrderSubscriptionPermissionApproval/GetPendingSubscriptionPlanPermissionMapping")
}

export function InactiveSubscriptionsPermissionsMappingGet() {
  return ObservableFromFetch<Permission[]>("FFOrderSubscriptionPermissionApproval/GetInActiveSubscriptionPlanPermissionMapping")
}

export function SubscriptionsPermissionsMappingApprove(permissions: Permission[], approvedBy: string) {
  const requestBody = JSON.stringify({
    ApproveSubscriptionPlanPermission: permissions,
    ApprovedBy: approvedBy
  })
  return ObservableFromFetch<string>("FFOrderSubscriptionPermissionApproval/ApprovedSubscriptionPlanPermissionMapping", requestBody)
}

// Role Permissions Approval
export function PendingRolePermissionsGet() {
  return ObservableFromFetch<Permission[]>("FFOrderRolePermissionApproval/GetPendingRolePermissionMapping")
}

export function InactiveRolePermissionsGet() {
  return ObservableFromFetch<Permission[]>("FFOrderRolePermissionApproval/GetInActiveRolePermissionMapping")
}

export function RolePermissionsApprove(permissions: Permission[], approvedBy: string) {
  const requestBody = JSON.stringify({
    ApproveRolePermission: permissions,
    ApprovedBy: approvedBy
  })
  return ObservableFromFetch<string>("FFOrderRolePermissionApproval/ApprovedRolePermissionMapping", requestBody)
}